import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCustom = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 416 416",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .08,
		d: "M240 32C240 14.3 225.7 0 208 0C190.3 0 176 14.3 176 32V176H32C14.3 176 0 190.3 0 208C0 225.7 14.3 240 32 240H176V384C176 401.7 190.3 416 208 416C225.7 416 240 401.7 240 384V240H384C401.7 240 416 225.7 416 208C416 190.3 401.7 176 384 176H240V32Z"
	}), /* @__PURE__ */ _jsx("path", { d: "M216 24C216 19.6 212.4 16 208 16C203.6 16 200 19.6 200 24V200H24C19.6 200 16 203.6 16 208C16 212.4 19.6 216 24 216H200V392C200 396.4 203.6 400 208 400C212.4 400 216 396.4 216 392V216H392C396.4 216 400 212.4 400 208C400 203.6 396.4 200 392 200H216V24Z" })]
});
export default SvgPlusCustom;
